import { IgCoreTextColors } from "@intelligems/ig-design-tokens/constants";
import type { SxProps, Theme } from "@mui/material/styles";

/**
 * The checkbox a multi-select row carries: the 16px control itself (the
 * theme pins every checkbox to a 32px hit box with `!important`, which would
 * add 8px of chrome to the row), with a 2px focus ring 4px out — 24px across,
 * centred on the box — while it has keyboard focus. The ring colour, Figma's
 * #1c2024, takes the nearest token, Text/Core/Primary.
 */
export const surveyCheckboxSx: SxProps<Theme> = {
  flexShrink: 0,
  p: 0,
  "&.MuiButtonBase-root.MuiCheckbox-root, &.MuiButtonBase-root.MuiRadio-root": {
    height: "16px !important",
    width: "16px !important",
  },
  "& .MuiSvgIcon-root": { fontSize: 16 },
  "&.Mui-focusVisible": {
    borderRadius: "2px",
    outline: `2px solid ${IgCoreTextColors.primary}`,
    outlineOffset: "2px",
  },
};
